import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { adminGuard } from './shared/guards/admin.guard';
import { authGuard } from './shared/guards/auth.guard';
import { mandantAdminGuard } from './shared/guards/mandant-admin.guard';
import { DashboardAdministrationComponent } from './views/dashboard-administration/dashboard-administration.component';
import { GlobalUserAdministrationComponent } from './views/global-user-administration/global-user-administration.component';
import { LoginComponent } from './views/login/login.component';
import { LogtoCallbackComponent } from './views/logto-callback/logto-callback.component';
import { MandantAdministrationComponent } from './views/mandant-administration/mandant-administration.component';
import { SettingsAdministrationComponent } from './views/settings-administration/settings-administration.component';
import { TileAdministrationComponent } from './views/tile-administration/tile-administration.component';
import { ToolsAndTrainingsComponent } from './views/tools-and-trainings/tools-and-trainings.component';
import { UserAdministrationComponent } from './views/user-administration/user-administration.component';
import { WelcomeComponent } from './views/welcome/welcome.component';
import { externalLoginGuard } from './shared/guards/external-login.guard';

const routes: Routes = [
  {
    path: 'admin',
    pathMatch: "full",
    redirectTo: '/admin/dashboard'
  },
  {
    path: 'admin',
    component: LayoutComponent,
    canActivateChild: [adminGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardAdministrationComponent
      },
      {
        path: 'tiles',
        component: TileAdministrationComponent
      },
      {
        path: 'tile-responsibility',
        loadComponent: () => import('./views/tile-responsibility-administration/tile-responsibility-administration.component').then(module => module.TileResponsibilityAdministrationComponent)
      },
      {
        path: 'feedback',
        loadComponent: () => import('./views/feedback-administration/feedback-administration.component').then(module => module.FeedbackAdministrationComponent)
      },
      {
        path: 'feedback/:reference',
        loadComponent: () => import('./views/feedback-administration/feedback-detail.component').then(module => module.FeedbackDetailComponent)
      },
      {
        path: 'mandants',
        component: MandantAdministrationComponent
      },
      {
        path: 'users',
        component: GlobalUserAdministrationComponent
      },
      {
        path: 'settings',
        component: SettingsAdministrationComponent
      },

    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: 'home',
        component: WelcomeComponent
      },
      {
        path: 'portal',
        component: ToolsAndTrainingsComponent
      },
      {
        canActivate: [mandantAdminGuard],
        path: 'users',
        component: UserAdministrationComponent
      },
      {
        path: 'verwaltung',
        canActivate: [mandantAdminGuard],
        canActivateChild: [mandantAdminGuard],
        loadComponent: () => import('./views/company-administration/company-administration.component').then(module => module.CompanyAdministrationComponent),
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'mitarbeiter' },
          { path: 'mitarbeiter', component: UserAdministrationComponent },
          { path: 'apps', component: ToolsAndTrainingsComponent, data: { manageTiles: true } },
          {
            path: 'meldung',
            loadComponent: () => import('./views/home-message-administration/home-message-administration.component').then(module => module.HomeMessageAdministrationComponent)
          },
        ]
      },


    ]
  },
  {
    path: 'externallogin/:token',
    canActivate: [externalLoginGuard],
    component: LoginComponent
  },
  {
    path: 'externallogin/:token/:target',
    canActivate: [externalLoginGuard],
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'callback',
    component: LogtoCallbackComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export function getRoutes() {
  return routes
}
